<!--
————————————————————————————————————————————————————————————————————————————————
—                                 TEMPLATE                                     —
————————————————————————————————————————————————————————————————————————————————
-->
<template>
  <div>
    <h1>{{ title }}</h1>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-4">
        <div class="my-componant no-border">
          <h1>Parent</h1>
          <p>Message (<strong>child1</strong>) : {{ msgChild1 }}</p>
          <p>Message (<strong>child2</strong>) : {{ msgChild2 }}</p>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-4">
        <CommunicateChild1 class="my-componant"></CommunicateChild1>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-4">
        <CommunicateChild2 class="my-componant lastChild"></CommunicateChild2>
      </div>
    </div>
  </div>
</template>

<!--
————————————————————————————————————————————————————————————————————————————————
—                                 SCRIPTS                                      —
————————————————————————————————————————————————————————————————————————————————
-->
<script>
import CommunicateChild1 from '../components/communicate-child1'
import CommunicateChild2 from '../components/communicate-child2'

import Bus from '../utils/bus.js'

export default {
  name: 'communicate',
  data () {
    return {
      title: 'Components communication with Bus',
      msgChild1: '',
      msgChild2: 'This is message 2'
    }
  },
  components: {
    CommunicateChild1,
    CommunicateChild2
  },
  created () {
    // console.log('Communicate-main created')
    // Intercepter event 1
    Bus.$on('updateMsgChild1', (msg) => {
      console.log('parent handling MsgChild1:' + msg)
      this.msgChild1 = msg
    })
    // Intercepter event 2
    Bus.$on('updateMsgChild2', (msg) => {
      console.log('parent handling MsgChild2:' + msg)
      this.msgChild2 = msg
    })
  },
  methods: { }
}
</script>

<!--
————————————————————————————————————————————————————————————————————————————————
—                                  STYLES                                      —
————————————————————————————————————————————————————————————————————————————————
-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../assets/stylesheets/_core/_var.scss';
  @import '../assets/stylesheets/_core/_breakpoints.scss';

  #app {
    .my-componant{
      .my-componant{
          margin-bottom:$marginBottom/2;
          &.lastChild{
            margin-bottom:0;
          }
      }
    }
  }

  @include media-breakpoint-up(sm) {
    #app {
      .my-componant{
        .my-componant{
          margin-bottom:$marginBottom/2;
        }
      }
    }
  }

  @include media-breakpoint-up(md) {
    #app {
      .my-componant{
        .my-componant{
          margin-bottom:0;
          &.no-border{
            margin-bottom:$marginBottom/2;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// communicate-main.vue?150d9af9